import { Component, Prop } from 'vue-property-decorator'

import Note from '@src/data/note'
import { NoteList } from '@src/routes/members/components/notes/list'
import Checkup from '@src/data/checkup'
import { CreateElement } from 'vue'
import { Loader } from '@src/components/loading-screen/loader/loader'
import { ErrorScreen } from '@src/components/error-screen/error-screen'
import { NoteRow } from '@src/routes/members/components/notes/note-row'

@Component
export class WizardNoteList extends NoteList {

  @Prop({ required: true })
  private checkup: Checkup

  @Prop({ required: false, default: false })
  private isReadonly: boolean

  constructor () {
    super()
  }

  filterNotes (list: Note[]) {
    let filteredNotes = list.filter(note => (!this.checkup.notesAdded && !this.isReadonly) || this.checkup.noteIds.includes(note.id))
    this.$store.dispatch('setFilteredNotes', filteredNotes)

    // sort notes list ASC by date
    return filteredNotes.sort(function (a, b) {
      // Turn your strings into dates, and then subtract them
      // to get a value that is either negative, positive, or zero.
      return b.createdAt.getTime() - a.createdAt.getTime()
    })
  }

  render (h: CreateElement) {
    if (this.loading) {
      return <Loader />
    }

    if (this.list.length === 0) {
      return <ErrorScreen message={this.$t('PAGE.MEMBERS.NOTES.NO_NOTES')} />
    }

    let filteredNotes: Note[] = this.filterNotes(this.list)
    let notes = filteredNotes.map(note => {
      return <NoteRow checkup={this.checkup} note={note} removeCallback={this.loadNotes}/>
    })

    if (notes.length === 0) {
      return <ErrorScreen message={this.$t('PAGE.MEMBERS.NOTES.NO_NOTES')} />
    }

    return <div class='notes'>{notes}</div>
  }
}
